export enum FilterOperationEnum {
  EQUALS = 'EQUALS',
  NOT_EQUALS = 'NOT_EQUALS',
  CONTAINS = 'CONTAINS',
  HAS_VALUE = 'HAS_VALUE',
  DOES_NOT_HAVE_VALUE = 'DOES_NOT_HAVE_VALUE',
  NOT_IN = 'NOT_IN',
  FROM = 'FROM',
  TO = 'TO',
  GREATER_THAN = 'GREATER_THAN',
  LESS_THAN = 'LESS_THAN',
  GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
  LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
  BETWEEN = 'BETWEEN',
  NOT_BETWEEN = 'NOT_BETWEEN',
  IN = 'IN',
}
